module.exports = {
  'lan': 'idTitle'
}
  